import { Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

export default function ExportProductosButton({ data }) {

  const exportar = async () => {

    if (!data || data.length === 0) {
      message.warning("No hay datos para exportar");
      return;
    }

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet("Productos");

    // Encabezado principal
    sheet.mergeCells("A1:I1");
    const title = sheet.getCell("A1");
    title.value = "Reporte de Productos";
    title.font = { size: 16, bold: true };
    title.alignment = { horizontal: "center" };

    sheet.addRow([]);

    const headers = [
      "PO",
      "Producto",
      "Tipo",
      "Proveedor",
      "Cantidad",
      "Unidad",
      "Valor COP",
      "Valor USD",
      "Entrega",
      "Estado"
    ];

    const headerRow = sheet.addRow(headers);

    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: "middle", horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFEFEFEF" }
      };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" }
      };
    });

    // Estados en español
    const estadoMap = {
      "finally closed": "Entregado",
      "closed": "Cerrado",
      "open": "Pendiente",
      "pending": "Pendiente"
    };

    data.forEach((p) => {

      const estado = estadoMap[p.estado?.toLowerCase()] || p.estado;

      sheet.addRow([
        p.Numero_PO,
        p.nombre_producto,
        p.tipo_producto,
        p.nombre,
        p.cantidad,
        p.unidad_medida,
        p.valor_unitario_COP,
        p.valor_unitario_USD,
        p.fecha_estimada_entrega
          ? dayjs(p.fecha_estimada_entrega).format("DD/MM/YYYY")
          : "",
        estado
      ]);

    });

    // Ajuste dinámico de columnas
    sheet.columns.forEach((column) => {

      let maxLength = 10;

      column.eachCell({ includeEmpty: true }, (cell) => {

        const length = cell.value ? cell.value.toString().length : 10;

        if (length > maxLength) {
          maxLength = length;
        }

      });

      column.width = Math.min(maxLength + 2, 40);

    });

    // Ajustar texto largo
    sheet.eachRow((row) => {

      row.eachCell((cell) => {

        cell.alignment = {
          wrapText: true,
          vertical: "middle"
        };

      });

    });

    const buffer = await workbook.xlsx.writeBuffer();

    const blob = new Blob([buffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    });

    saveAs(blob, `productos_${dayjs().format("YYYYMMDD_HHmm")}.xlsx`);

  };

  return (
    <Button
      icon={<DownloadOutlined />}
      onClick={exportar}
      type="default"
    >
      Exportar
    </Button>
  );
}